/**
 * Sims
 * http://simsrecycling.com
 *
 * Copyright (c) 2017 10up
 * Licensed under the GPL-2.0+ license.
 */

( function( window, $ ) {
	'use strict';

	var $window = $( window );

	window.GoogleMapsLoaded = function() {
		// Trigger a custom event we can tie into.
		$window.trigger( 'google_maps_loaded' );
	};

} )( window, jQuery );
